import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_142_receipt_summary: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Receipt summary",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              margin: 0,
              marginBottom: 8,
            },
            childComponents: [],
          },
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "reciept_no",
            Name: "credit_summary",
            BindValue: "grid_debit_summary",
            SummeryActions: [
              {
                Action: {
                  Action: "PDF",
                  Settings: "reciept_voucher",
                },
                ActionType: ActionType.PDF_DOWNLOAD,
                tooltip: "Download PDF",
              },
            ],
            Form: {
              Name: "credit_summary",
              TableName: "view_credit_records",
              View: "view_credit_records",
              DisplayName: "credit_summary",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "No.",
                  BindValue: "voucher_no",
                  Json_Attribute: "reciept_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Date",
                  BindValue: "transact_date",
                  Json_Attribute: "date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Customer name",
                  BindValue: "customername",
                  Json_Attribute: "customername",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Customer address",
                  BindValue: "address",
                  Json_Attribute: "Address",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Transaction type",
                  BindValue: "transact_type",
                  Json_Attribute: "transaction_type",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Amount",
                  BindValue: "transact_debit",
                  Json_Attribute: "credit",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Discount",
                  BindValue: "txt_discount",
                  Json_Attribute: "discount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Bill mode",
                  BindValue: "transact_payment_mode",
                  Json_Attribute: "payment_mode",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Details",
                  BindValue: "transact_remarks",
                  Json_Attribute: "remarks",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
          {
            componentType: ComponentType.REPORT,
            Label: "",
            BindValue: "cus_report",
            Settings: "customers_report",
            IncludeLabel: true,
            passid: false,
          },
        ],
      },
    ],
  },
];
